<template>
  <div class="panel panel-default form-widget" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <form method="post" action="/pickup" @submit.prevent="submitForm" id="quote-form" novalidate>
      <div class="panel-heading">
        <h3>Schedule a USA Pickup</h3>
      </div>
      <div>
        <ol class="indicators">
          <li v-for="(indicator, index) in indicators" v-bind:class="{active: currentPage === index}"></li>
        </ol>
        <carousel
            :loop="true"
            v-on:pageChange="currentPage = $event"
            :touchDrag="false"
            :mouseDrag="false"
            ref="carousel"
            :perPage="1"
            :paginationEnabled="false"
            :adjustableHeight="true"
        >
          <slide data-name="Start" class="panel-body first slide1">
            <div class="form-group material">
              <input v-model="name" autocomplete="name" type="text" :class="inputClass(name)" id="name" name="name" :tabindex="isTabbable(0)" required>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="name">Name</label>
            </div>
            <div class="form-group material">
              <input v-model="email" autocomplete="email" type="email" :class="inputClass(email)" id="email" name="email" :tabindex="isTabbable(0)" required>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="email">Email</label>
            </div>
            <div class="form-group material">
              <input type="text" :class="inputClass(phone)" v-mask="'(###) ###-####'" id="phone" name="phone" v-model="phone"
                     :tabindex="isTabbable(0)" required>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="phone">{{ phoneText }}</label>
            </div>
            <div class="form-group material inline">
              <input type="checkbox" id="sms_updates" name="sms_updates" v-model="sms_updates" value="1">
              <label for="sms_updates" class="checkbox">Send me sms updates about my pickup to this
                number</label>
            </div>
          </slide>
          <slide data-name="Parcel Location" class="panel-body slide2">
            <div class="form-group">
              <label for="parcel_location">Parcel Location</label>
              <select id="parcel_location"
                      name="parcel_location_id"
                      class="form-control"
                      title="Parcel Location"
                      v-model="parcel_location"
                      :tabindex="isTabbable(1)"
                      required>
                <option value="">Select a location</option>
                <option
                    v-for="parcelLocation in parcelLocations"
                    :value="parcelLocation.id">
                  {{parcelLocation.name}}
                </option>
                <option>Other</option>
              </select>
            </div>
            <div class="form-group" v-if="parcel_location == 'Other'">
              <label>Pickup Location Name and Address</label>
              <div class="form-group material">
                <input type="text" class="form-control" id="parcel_location_name" name="parcel_location_name" :tabindex="isTabbable(1)" required>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label for="parcel_location_name">Location Name</label>
              </div>
              <div class="form-group material">
                <input type="text" class="form-control" id="parcel_location_address_line_1" name="parcel_location_address_line_1" :tabindex="isTabbable(1)" required>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label for="parcel_location_address_line_1">Address</label>
              </div>
              <div class="form-group material">
                <input type="text" class="form-control" id="parcel_location_city" name="parcel_location_city" :tabindex="isTabbable(1)" required>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label for="parcel_location_city">City</label>
              </div>
              <div class="form-group form-row">
                <div class="col-6 material">
                  <select class="form-control" id="parcel_location_province" name="parcel_location_province" :tabindex="isTabbable(1)" required>
                    <option value=""></option>
                    <option value="ND">ND</option>
                    <option value="MN">MN</option>
                  </select>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label for="parcel_location_province">State</label>
                </div>
                <div class="col-6 material">
                  <input type="text" class="form-control" id="parcel_location_postcode" name="parcel_location_postcode" :tabindex="isTabbable(1)" required>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label for="parcel_location_postcode">Zipcode</label>
                </div>
              </div>
            </div>
          </slide>
          <slide data-name="Shipment Arrived" class="panel-body slide3">
            <div class="form-group">
              <label>Has your shipment arrived {{parcel_location == 'Other' ? 'at its destination?' : 'in Pembina?'}}</label><br>
              <label class="radio-inline">
                <input type="radio"
                       name="has_shipment_arrived"
                       id="has_shipment_arrived_yes"
                       value="1"
                       :tabindex="isTabbable(2)"
                       required> Yes
              </label>
              <label class="radio-inline">
                <input type="radio"
                       name="has_shipment_arrived"
                       id="has_shipment_arrived_no"
                       value="0"
                       :tabindex="isTabbable(2)"
                       required> No
              </label>
            </div>
            <div class="form-group material">
              <input type="text"
                     class="form-control"
                     id="tracking_number"
                     :tabindex="isTabbable(2)"
                     name="tracking_number">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="tracking_number">Tracking # (if available)</label>
            </div>
          </slide>
          <slide data-name="Package Info" class="panel-body slide4">
            <div class="form-group material">
              <input type="number"
                     class="form-control"
                     id="number_of_packages"
                     name="number_of_packages"
                     v-model.number="package_count"
                     :tabindex="isTabbable(3)"
                     required>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="number_of_packages">Number of packages</label>
            </div>
            <div class="form-group material">
              <input type="number"
                     class="form-control"
                     id="total_weight"
                     name="total_weight"
                     v-model.number="shipment_weight"
                     :tabindex="isTabbable(3)"
                     required>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="total_weight">Total weight in lbs (approx)</label>
            </div>
            <div class="form-group material">
              <input type="number"
                     class="form-control"
                     id="value_of_goods_usd"
                     name="value_of_goods_usd"
                     v-model="shipment_value"
                     :tabindex="isTabbable(3)"
                     required>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="value_of_goods_usd">Value of all Goods (USD)</label>
            </div>
          </slide>
          <slide data-name="Estimated Cost" class="panel-body slide5">
            <p>Here is your estimated shipping costs. If you’d like to proceed please continue and we will
              contact you with the finalized shipping fees once we’ve reviewed the order.</p>
            <p>Estimated Fee: <strong>{{ total | formattedPrice }}<sup style="color:#8e8e8e">*</sup> <small
                style="font-size: 12px;color: #8E8E8E;font-weight: normal;">+ Customs tax and parcel
              fees</small></strong></p>
            <p style="font-size: 11px; font-style: italic">* This brokerage fee is for a basic one invoice entry with 10 lines of product or less. Extra invoices/lines of product that requires extra classification may result in extra fees.</p>
          </slide>
          <slide data-name="Delivery Location" class="panel-body slide6">
            <div class="form-group">
              <label for="delivery_location">Delivery Location</label>
              <select id="delivery_location"
                      name="delivery_location"
                      class="form-control"
                      title="Delivery Location"
                      v-model="delivery_location"
                      :tabindex="isTabbable(4)"
                      required>
                <option :value="null">Select a Delivery Location</option>
                <option>Winnipeg - 2-615 Camiel Sys Street</option>
                <option value="Other">Other/Home Delivery</option>
              </select>
            </div>
            <div class="form-group" v-if="delivery_location == 'Other'">
              <label for="delivery_location_address">Delivery Location Name and
                Address</label>
              <br><small>Additional fees may apply</small>
              <textarea class="form-control"
                        id="delivery_location_address"
                        name="delivery_location_address"
                        :tabindex="isTabbable(4)"
                        :required="delivery_location == 'Other'"></textarea>
            </div>
          </slide>
          <slide data-name="Legal Info" class="panel-body slide7">
            <legal-form :is-tabbable="isTabbable(5)"></legal-form>
          </slide>
          <slide data-name="Broker Info" class="panel-body slide8">
            <div class="form-group">
              <label>Do you have a broker?</label><br>
              <label class="radio-inline">
                <input v-model="do_you_have_a_broker"
                       type="radio"
                       name="do_you_have_a_broker"
                       id="do_you_have_a_broker_yes"
                       :tabindex="isTabbable(7)"
                       value="1"
                       required> Yes
              </label>
              <label class="radio-inline">
                <input v-model="do_you_have_a_broker"
                       type="radio"
                       name="do_you_have_a_broker"
                       id="do_you_have_a_broker_no"
                       value="0"
                       :tabindex="isTabbable(7)"
                       required> No
              </label>
            </div>
            <div class="form-group" v-if="do_you_have_a_broker == 1">
              <label for="importer_name_address">Broker Name</label>
              <input class="form-control"
                     id="broker_name"
                     name="broker_name"
                     :tabindex="isTabbable(7)"
                     :required="do_you_have_a_broker == 1">
            </div>
            <div class="form-group" v-if="do_you_have_a_broker == 1">
              <label for="importer_name_address">Broker Number</label>
              <input class="form-control"
                     id="broker_number"
                     name="broker_number"
                     :tabindex="isTabbable(7)"
                     :required="do_you_have_a_broker == 1">
            </div>
          </slide>
          <slide data-name="Description of Goods" class="panel-body slide9">
            <div class="form-group">
              <label>Multiple Shipments</label><br>
              <label class="radio-inline">
                <input v-model="multiple_shipments"
                       type="radio"
                       name="multiple_shipments"
                       id="multiple_shipments_yes"
                       value="1"
                       :tabindex="isTabbable(8)"
                       required> Yes
              </label>
              <label class="radio-inline">
                <input v-model="multiple_shipments"
                       type="radio"
                       name="multiple_shipments"
                       id="multiple_shipments_no"
                       value="0"
                       :tabindex="isTabbable(8)"
                       required> No
              </label>
            </div>
            <div class="form-group" v-if="multiple_shipments == 1">
              <label for="multiple_shipments_info">Submit the following for each shipment:
                Seller Name / Description of Goods / Value (USD) / Country of
                Manufacture</label>
              <textarea class="form-control"
                        id="multiple_shipments_info"
                        name="multiple_shipments_info"
                        :tabindex="isTabbable(8)"
                        :required="multiple_shipments == 1"></textarea>
            </div>
            <div class="form-group material" v-if="multiple_shipments == 0">
              <input type="text"
                     class="form-control"
                     id="name_of_seller_or_vendor"
                     name="name_of_seller_or_vendor"
                     :tabindex="isTabbable(8)"
                     :required="multiple_shipments == 0">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="name_of_seller_or_vendor">Name of Seller/Vendor</label>
            </div>
            <div class="form-group material" v-if="multiple_shipments == 0">
              <input type="text"
                     class="form-control"
                     id="description_of_goods"
                     name="description_of_goods"
                     :tabindex="isTabbable(8)"
                     :required="multiple_shipments == 0">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="description_of_goods">Description of Goods</label>
            </div>
            <div class="form-group material" v-if="multiple_shipments == 0">
              <input type="text"
                     class="form-control"
                     id="country_of_manufacture"
                     name="country_of_manufacture"
                     :tabindex="isTabbable(8)"
                     :required="multiple_shipments == 0">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label for="country_of_manufacture">Country Of Manufacture</label>
              <small>If multiple countries, please list them all above.</small>
            </div>
          </slide>
          <slide data-name="Upload Invoice" class="panel-body submit slide10">
            <label>Upload Invoices</label><br>
            <small>Allowed files: jpg, png, pdf. 2MB max each.<br>When file browser opens
              hold ctrl (PC) cmd (Mac) to select multiple files</small>
            <input style="margin-top: 20px;"
                   id="invoices"
                   type="file"
                   name="invoices[]"
                   :tabindex="isTabbable(9)"
                   multiple/>

            <div v-if="!isLoggedIn" class="form-check" style="margin-top: 20px;">
              <input type="checkbox" v-model="create_account" class="form-check-input" id="create_account" name="create_account" :tabindex="isTabbable(9)">
              <label class="form-check-label" for="create_account">Create Account</label>
            </div>
            <div v-if="create_account" class="form-check" style="margin-top: 20px;">
              <input type="password" v-model="password" minlength="8" class="form-control" id="password" name="password" placeholder="password" :tabindex="isTabbable(9)" :required="create_account">
            </div>
            <div class="form-check" style="margin-top: 20px;">
              <input type="checkbox" class="form-check-input" id="terms_accepted" name="terms_accepted" :tabindex="isTabbable(9)" required>
              <label class="form-check-label" for="terms_accepted">I accept the</label> <a :tabindex="isTabbable(9)" target="_blank" href="/terms">terms of service</a>
            </div>
          </slide>
          <slide class="panel-body step item slide11">
            <div class="circle-check">&#x2714;</div>
            <p>Thank you. Your pickup request was sent successfully. We'll contact you
              within 1 business day to confirm pickup.</p>
          </slide>
        </carousel>
      </div>
      <div class="panel-footer text-center row">
        <div class="col-xs-4">
          <button v-if="currentPage > 0" class="btn btn-link btn-prev btn-block" v-on:click.prevent="move('prev')">
            Back
          </button>
        </div>
        <div class="col-xs-8">
          <vue-recaptcha
              ref="recaptcha"
              :sitekey="recaptchaPublicKey"
              :loadRecaptchaScript="true"
              @verify="submitForm"
              size="invisible"
          >
            <button
                id="submit"
                class="btn btn-primary btn-next btn-block"
                :disabled="loading"
                v-show="currentPage === 9"
                :tabindex="isTabbable(9)"
            >
              Submit &#x21e8;
            </button>
          </vue-recaptcha>
          <button
              id="next"
              class="btn btn-primary btn-next btn-block"
              v-on:click.prevent="move('next')"
              v-show="currentPage !== 9"
              :disabled="loading"
          >
            {{ nextText }} &#x21e8;
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {clearanceFeeLookup, singleParcelPrice, weightLookup} from '../pricing'
import VueRecaptcha from 'vue-recaptcha';
import {Carousel, Slide} from 'vue-carousel';
import {useUserStore} from "../stores/user";
import {storeToRefs} from "pinia";
import {ref} from "vue";

export default {
  components: {VueRecaptcha, Carousel, Slide},
  setup: () => {
    const userStore = useUserStore()

    userStore.fetchMe();
    const {name, email, customerType, isLoggedIn} = storeToRefs(userStore)

    return {
      // legalInfo,
      customerType,
      // first_name,
      // last_name,
      isLoggedIn,
      email,
      name,
    }
  },
  props: {
    recaptchaPublicKey: {
      type: String,
      required: true,
    },
    parcelLocations: {
      type: Array,
      required: true,
    }
  },
  data: () => ({
    loading: false,
    formActionText: 'Next',
    parcel_location: "Mike's Parcel - Pembina",
    // delivery_location: "St. Anne's Storage - Winnipeg Pick-up Facility",
    delivery_location: null,
    multiple_shipments: null,
    customer_type: null, // shipment_type
    do_you_have_a_broker: null,
    shipment_weight: null,
    shipment_value: null,
    package_count: null,
    phone: '',
    sms_updates: 0,
    shipment_weight_other: 0,
    shipment_value_other: 0,
    isSubmitSlide: false,
    indicators: [],
    currentPage: 0,
    create_account: false,
    // name: '',

  }),
  mounted: function () {
    const count = this?.$refs?.carousel?.slideCount;
    this.indicators = new Array(count);

    // const userStore = useUserStore()
    // userStore.$onAction(
    //     ({
    //        name, // name of the action
    //        store, // store instance, same as `someStore`
    //        args, // array of parameters passed to the action
    //        after, // hook after the action returns or resolves
    //        onError, // hook if the action throws or rejects
    //      }) => {
    //       if (name === 'fetchMe') {
    //         after(() => {
    //           if (userStore.legalInfo) {
    //
    //             this.name = userStore.legalInfo.first_name
    //             this.email = userStore.legalInfo.email
    //           }
    //         })
    //       }
    //     })

    // userStore.fetchMe();

  },
  methods: {
    inputToNiceName: function (inputName) {
      inputName = inputName.replace('_', ' ');
      return inputName.replace(/\b\w/g, function (l) {
        return l.toUpperCase()
      });
    },

    move: function (action) {
      // We have to do this since vue-carousel doesn't put the active class on the first slide
      const active = this.$el.querySelector('.panel-body.VueCarousel-slide-active');
      const first = this.$el.querySelector('.panel-body.first')
      var currentSlide = this.currentPage === 0 ? first : active;

      if(!this.validateSlide(currentSlide, action)){
        return false;
      }

      if (action === 'next') {
        // We only push events here when there's a named slide. The actual form completion
        // gets pushed in the submitForm() method so we can detect if it was 200 success
        const slideName = currentSlide.getAttribute('data-name');
        if(slideName){
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: "USA Pickup",
            action: "Form Progression",
            label: (this.currentPage + 1).toString().padStart(2, 0) + " " + slideName,
            value: this.total,
          });
        }

        this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage())
      } else if (action === 'prev') {
        this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage())
      }
    },
    validateSlide: function(el, action){
      var errors = [];
      var checkedRadios = [];
      var me = this;

      // validate  the current panel
      $.each($(el).find('input, textarea, select').filter('[required]:visible'),
          function () {
            var $el = $(this);

            if ($el.attr('type') === 'radio') {
              // We need to check our radio fields differently.
              if (checkedRadios.indexOf($el.attr('name')) === -1 && !$('input[name=' + $el.attr(
                  'name') + ']:checked').val()) {
                errors.push(me.inputToNiceName($el.attr('name')) + ' is required');
                checkedRadios.push($el.attr('name'));
              }
            } else if ($el.attr('type') === 'checkbox' && !$el.is(":checked")) {
              errors.push(me.inputToNiceName($el.attr('name')) + ' is required');
            } else if (!$el.val()) {
              // All other fields
              errors.push(me.inputToNiceName($el.attr('name')) + ' is required');
            }

            if ($el.attr('type') === 'email') {
              var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (!re.test($el.val())) {
                errors.push('Please provide a valid email');
              }
            }
          });

      if (errors.length && action != 'prev') {
        alert(errors.join("\n"));
        return false;
      }

      return true;
    },
    isTabbable: function (page) {
      return this.currentPage === page ? 0 : -1;
    },

    inputClass: function (val, classes = '') {
      return val ? 'form-control used ' + classes : 'form-control ' + classes;
    },

    submitForm: function (recaptchaToken) {
      const active = this.$el.querySelector('.panel-body.VueCarousel-slide-active');
      if(!this.validateSlide(active, 'next')){
        grecaptcha.reset();
        return false;
      }

      var me = this;
      this.loading = true;
      var form = $('#quote-form').get(0);
      var formData = new FormData(form);
      formData.append('g-recaptcha-response', recaptchaToken);

      axios({
        url: '/pickup',
        method: 'post',
        data: formData,
        headers: {
          accept: 'application/json',
        },
      })
          .then(function (data) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "USA Pickup",
              action: "Form Progression",
              label: "Completed",
              value: me.total,
            });

            me.move('next');
            form.reset();
          })
          .catch(function (error) {
            if (error?.response?.status == 422) {
              var messages = '';
              $.each(error?.response?.data, function (index, message) {
                messages += "\n" + message.join("\n");
              });
              alert('There was a problem submitting the form. Please fix the following errors: ' + messages);
            } else {
              alert('There was a problem submitting the form. Please contact us at info@runninred.com or 888-699-0990.');
            }
          })
          .finally(() => {
            this.loading = false;
            grecaptcha.reset();
          })
    }
  },
  computed: {
    buttonText: function () {
      return this.formActionText;
    },
    nextText: function () {
      return this.indicators.length - 1 === this.currentPage ? 'Start Over' : 'Next';
    },
    phoneText: function () {
      return this.sms_updates ? 'Mobile Phone' : 'Phone';
    },
    transportation_fee: function () {
      var me = this;
      var weightClass = weightLookup.filter(function (weight) {
        return me.shipment_weight > weight.min && me.shipment_weight <= weight.max;
      });

      return weightClass.length ? weightClass[0].price : this.shipment_weight * 7;
    },
    clearance_fee: function () {
      var maxClearance = clearanceFeeLookup[clearanceFeeLookup.length - 1];

      if (this.shipment_value > maxClearance.max) {

        var excess = Math.ceil((this.shipment_value - maxClearance.max - 1) / 1000);
        return maxClearance.price + (excess * 1000);
      }

      var me = this;
      var clearanceFee = clearanceFeeLookup.filter(function (clearance) {
        return me.shipment_value > clearance.min && me.shipment_value <= clearance.max;
      });

      return clearanceFee.length ? clearanceFee[0].price : 0;
    },
    e_manifest_fee: function () {
      return 700;
    },
    other_parcel_location_fee: function () {
      return this.parcel_location === 'Other' ? 10 : 0;
    },
    total: function () {
      return (this.transportation_fee + this.clearance_fee + this.e_manifest_fee + this.other_parcel_location_fee).toFixed(2);
    }
  }
}
</script>
